import { Decimal, formatTrDate, formatTrDateTime, type LocalDate } from "@station/core";

/** Görüntüleme her zaman Türkiye biçiminde ve İstanbul saatindedir (AGENTS.md §3.3, §6): `18.09.2026`, `18.09.2026 14:05`. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return "—";
  return /^\d{4}-\d{2}-\d{2}$/.test(value) ? formatTrDate(value as LocalDate) : formatTrDate(new Date(value));
}

export function formatDateTime(value: string | null | undefined): string {
  return value ? formatTrDateTime(new Date(value)) : "—";
}

/** Birim fiyat (numeric(18,4), KDV dâhil): en az 2, gerekiyorsa 4 ondalık — `43,21 ₺`, `12,495 ₺`. Float kullanılmaz. */
export function formatUnitPrice(value: string | null | undefined): string {
  if (!value) return "—";
  const decimals = (value.split(".")[1] ?? "").replace(/0+$/, "").length;
  return `${Decimal.from(value).formatTr(Math.max(2, Math.min(4, decimals)))} ₺`;
}

/** İki fiyat arasındaki yüzde fark: `+%3,50`. Önceki fiyat yoksa boş. */
export function formatPriceChange(
  previous: string | null | undefined,
  next: string | null | undefined,
): string {
  if (!previous || !next) return "";
  const change = Decimal.from(next).sub(previous).mul(100).div(previous).round(2);
  return `${change.isNegative() ? "−" : "+"}%${change.abs().formatTr(2)}`;
}

/** Tam sayı (adet, işlem sayısı): binlik ayırıcılı Türkiye biçimi — `2.084`. */
export function formatCount(value: number | null | undefined): string {
  return value === null || value === undefined ? "—" : new Intl.NumberFormat("tr-TR").format(value);
}
